import { render, staticRenderFns } from "./appProductSlider.vue?vue&type=template&id=6554b128"
import script from "./appProductSlider.vue?vue&type=script&lang=js"
export * from "./appProductSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports